<template>
    <div class="course-page">
        <!-- 1、顶部菜单栏 -->
        <div class="course-title-bar dsp-flex">
            <div class="bg1"></div><div class="bg2"></div>
            <div class="title-side title-yellow">
                <span class="title-back discuss-title-back" @click="clickBack">
                    <i class="iconfont icon-xiangzuo"></i>
                </span>
            </div>
            <div class="title-middle">
                <span>正在学习</span>
            </div>
        </div>
        <!-- 2、课程播放视频 -->
        <div class="course-video-content">
            <div class="course-video" id="J_prismPlayer"></div>
            <div class="course-catalogue" @click="clickCatalogue">
                <span class="course-catalogue-title">目录</span>
                <span class="course-catalogue-arrow"><i class="iconfont icon-xiangyou"></i></span>
            </div>
        </div>
        <!-- 3、课程信息 -->
        <div class="course-info-content course-info-content-2">
            <h3 class="course-title">{{ curCourseDetailInfo.f_title }}</h3>
            <p class="course-info-p">{{ curCourseDetailInfo.timeStr }} | {{ curCourseDetailInfo.f_times }}次学习</p>
            <p class="course-intro-p" v-html="UTILS.getBreakLineByText(curCourseDetailInfo.f_intro)"></p>
        </div>
        <van-popup class="course-catalogue-popup" v-bind:value="showCataloguePopup" position="bottom" @click-overlay="clickShowCatalogueOverlay">
            <course-catalogue-popup></course-catalogue-popup>
        </van-popup>
    </div>
</template>

<script>
import { MIX, UTILS } from '../../modules/utils';
import CourseCataloguePopup from '../../layouts/course/CourseCataloguePopup.vue'
export default {
    name: 'Course',
    components: { CourseCataloguePopup },
    computed: {
        curCourseVideoInfo() {
            return this.$store.state.course.curCourseVideoInfo;
        },
        curCourseDetailInfo() {
            return this.$store.state.course.curCourseDetailInfo;
        },
        showCataloguePopup() {
            return this.$store.state.course.showCataloguePopup;
        }
    },
    data() {
        return {
            UTILS: UTILS,
            showCatalogue: false,
            videoPlayer: undefined,
        }
    },
    mounted: function() {
        this.$bus.on('replayCourseVideo', this.replayVideo);
        setTimeout(() => {
            if(!this.curCourseVideoInfo || !this.curCourseVideoInfo.playAuth) {
                this.clickBack();
                return;
            }
            if(this.curCourseVideoInfo.playAuth) {
                this.playVideo();
            }
            window.scrollTo(0, 0);
            MIX.trackPageViewed('VideoPlayPage');
        }, 20);
    },
    destroyed() {
        this.$bus.on('replayCourseVideo', this.replayVideo);
    },
    methods: {
        clickBack() {
            let curParams = this.$router.history.current.params;
            console.log('clickBack-----', curParams);
            if(curParams.from.indexOf('coursedetail') != -1) {
                let from = curParams.from;
                    from = from.replace('-', '/');
                this.$router.replace('/'+from);
            }else if(curParams.from == 'courserecord') {
                this.$router.replace('/courserecord');
            }
        },
        playVideo() {
            console.log('curCourseDetailInfo----', this.curCourseDetailInfo.f_pic);
            this.videoPlayer = new Aliplayer({
                id: 'J_prismPlayer',
                width: '100%',
                skinLayout:[
                    {name: "H5Loading", align: "cc"},
                    {name: "errorDisplay", align: "tlabs", x: 0, y: 0},
                    {name: "infoDisplay"},
                    {name:"tooltip", align:"tcabs",x: 0, y: 56},
                    {name: "thumbnail"},
                    {
                        name: "controlBar", align: "blabs", x: 0, y: 0,
                        children: [
                            {name: "progress", align: "blabs", x: 0, y: 44},
                            {name: "playButton", align: "tl", x: 15, y: 12},
                            {name: "timeDisplay", align: "tl", x: 10, y: 7},
                            {name: "fullScreenButton", align: "tr", x: 10, y: 12},
                            {name: "subtitle", align:"tr",x:15, y:12},
                            {name: "setting", align:"tr",x:15, y:12},
                            {name: "volume", align: "tr", x: 5, y: 10}
                        ]
                    }
                ],
                skinLayoutIgnore: [
                    'tooltip',
                    'bigPlayButton', // 隐藏大播放按钮 
                    'controlBar.timeDisplay',
                    'controlBar.subtitle',
                    // 'controlBar.setting.quality',
                    // 'controlBar.fullScreenButton' // 隐藏控制条上的全屏按钮（通过点运算符进行子组件选择）
                ],
                vid : this.curCourseVideoInfo.videoId, // 必选参数。音视频ID。示例：1e067a2831b641db90d570b6480f****。
                playauth : this.curCourseVideoInfo.playAuth, // 必选参数。音视频播放凭证。
                cover: this.curCourseDetailInfo.f_pic, //图片
                // authTimeout: 7200, // 播放地址的有效时长，单位：秒。该时长会覆盖在视频点播控制台设置的URL鉴权的有效时长。如果不传，则取默认值7200。如需设置此参数，请确保该时间大于视频的实际时长，防止播放地址在播放完成前过期。

            },function(player){
                console.log('The player is created.');
            });
            console.log('player-----', this.videoPlayer);
            this.videoPlayer.on('playing', this.onVideoPlayingFunc);
            this.videoPlayer.on('timeupdate', this.onVideoTimeUpdateFunc);
        },
        onVideoPlayingFunc(e) {
            let vTime = parseInt(this.videoPlayer.getCurrentTime());
            let vDuration = parseInt(this.videoPlayer.getDuration());
            let percentage = parseInt((vTime/vDuration)*100);
                percentage = percentage >= 1 ? percentage : 1; 
            console.log('onVideoPlayingFunc-----', vTime, vDuration, percentage);
            this.$store.dispatch('course/updateCourseVideoPercentage', {
                percentage: percentage
            })

        },
        onVideoTimeUpdateFunc(e) {
            let vTime = parseInt(this.videoPlayer.getCurrentTime());
            let vDuration = parseInt(this.videoPlayer.getDuration());
            if(parseInt(vTime/30) >= 1 && vTime%30 == 0) {
                let percentage = parseInt((vTime/vDuration)*100);
                    percentage = percentage >= 1 ? percentage : 1; 
                console.log('onVideoTimeUpdateFunc-----', vTime, vDuration, percentage);
                this.$store.dispatch('course/updateCourseVideoPercentage', {
                    percentage: percentage
                });
            }
        },
        replayVideo() {
            console.log('replayVideo----', this.curCourseVideoInfo);
            if(this.curCourseVideoInfo.videoId && this.curCourseVideoInfo.playAuth) {
                this.videoPlayer.replayByVidAndPlayAuth(this.curCourseVideoInfo.videoId, this.curCourseVideoInfo.playAuth);
            }
        },
        clickCatalogue() {
            this.$store.state.course.showCataloguePopup = true;
        },
        clickShowCatalogueOverlay() {
            this.$store.state.course.showCataloguePopup = false;
        }
    }
}
</script>
